import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPagedResults } from 'src/app/core/models/base';
import { IAttachmentResponse, IUploadAttachmentResponse } from 'src/app/shared/services/attachment.service';
import { environment } from 'src/environments/environment';
import {
  ICreateInventoryDeviceRequest,
  ICreateInventoryDeviceServiceRequest,
  IGetAttachmentsByInventoryDeviceRequest,
  IInventoryDevice,
  IInventoryDeviceDetails,
  ISearchInventoryDevicesRequest,
  IUpdateInventoryDeviceRequest,
  IUpdateInventoryDeviceServiceRequest
} from '../models/inventory-device';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  private readonly baseUrl = `${environment.baseUrl}/v1/inventoryDevices`;

  constructor(private http: HttpClient) { }

  // Inventory device
  searchInventoryDevices(request: ISearchInventoryDevicesRequest) {
    return this.http.post<IPagedResults<IInventoryDevice[]>>(
      `${this.baseUrl}/searchInventoryDevices`,
      request
    )
  }

  getInventoryDeviceById(id: string) {
    return this.http.get<IInventoryDeviceDetails>(
      `${this.baseUrl}/getInventoryDevice/${id}`
    )
  }

  createInventoryDevice(request: ICreateInventoryDeviceRequest) {
    return this.http.post<IInventoryDeviceDetails>(
      `${this.baseUrl}/createInventoryDevice`,
      request
    )
  }

  updateInventoryDevice(request: IUpdateInventoryDeviceRequest) {
    return this.http.put<IInventoryDeviceDetails>(
      `${this.baseUrl}/updateInventoryDevice/${request.id}`,
      request
    )
  }

  deleteInventoryDevice(id: string) {
    return this.http.delete<string>(
      `${this.baseUrl}/deleteInventoryDevice/${id}`
    )
  }

  // Services (maintenance entries) - every call returns the updated device incl. the recalculated next service date
  createInventoryDeviceService(request: ICreateInventoryDeviceServiceRequest) {
    return this.http.post<IInventoryDeviceDetails>(
      `${this.baseUrl}/createInventoryDeviceService`,
      request
    )
  }

  updateInventoryDeviceService(request: IUpdateInventoryDeviceServiceRequest) {
    return this.http.put<IInventoryDeviceDetails>(
      `${this.baseUrl}/updateInventoryDeviceService/${request.id}`,
      request
    )
  }

  deleteInventoryDeviceService(id: string) {
    return this.http.delete<IInventoryDeviceDetails>(
      `${this.baseUrl}/deleteInventoryDeviceService/${id}`
    )
  }

  // Attachments (download / thumbnails are handled by the shared AttachmentService)
  uploadAttachment(formData: FormData) {
    return this.http.post<IUploadAttachmentResponse>(
      `${this.baseUrl}/uploadInventoryDeviceAttachment`,
      formData
    )
  }

  getAttachmentsByInventoryDevice(request: IGetAttachmentsByInventoryDeviceRequest) {
    return this.http.post<IPagedResults<IAttachmentResponse[]>>(
      `${this.baseUrl}/getAttachmentsByInventoryDevice`,
      request
    )
  }

  deleteAttachment(id: string) {
    return this.http.delete(
      `${this.baseUrl}/deleteInventoryDeviceAttachment/${id}`
    )
  }
}